import {moneyFormatter} from "../../lib/formatters";
import {Input} from "../ui/input";

/**
 * string -> USD number string
 * */
export function USDonChange(value: string) {
    if (value === "") {
        return "";
    }
    const rawValue = value.replace(/[$,]/g, "");
    const parsedValue = parseFloat(rawValue);

    if (!isNaN(parsedValue)) {
        return parsedValue.toString();
    } else {
        return ""
    }
}


export function USDtoValue(value: any) {
    return value ? moneyFormatter.format(Number(value)) : ""
}

